export const SIDEBAR_WIDTH = "300px";
export const NAVBAR_HEIGHT = 64;
